export default "__VITE_ASSET__BkejhNA___"